module.exports = __webpack_public_path__ + "static/media/81+BptkOmnL._SL1500_.66a55aeb.jpg";